var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconLike1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 20"
  }, props), /*#__PURE__*/React.createElement("linearGradient", {
    id: "myplace_likeit_feed_path1",
    gradientUnits: "userSpaceOnUse",
    x1: -884.8374,
    y1: 511.8799,
    x2: -884.3034,
    y2: 512.3732,
    gradientTransform: "matrix(18.929 0 0 -18.959 16760.0762 9718.3184)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D82A3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FC4E5F"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#myplace_likeit_feed_path1)",
    d: "M17.4,0.5l-12,12l6.9,6.9L24.1,7.7l0.3-0.3l-0.3-0.3L17.4,0.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FD4E60",
    d: "M7.2,0.5L0.5,7.2L0.3,7.4l0.3,0.3l11.8,11.8l0,0l6.9-6.9l-6.9-6.9L7.2,0.5z"
  })));
}
export default SvgCommonIconLike1;